module.exports = __webpack_public_path__ + "8081474e67ebc8daf921bb3b4a572917.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/devicon/devicon.woff2
 ** module id = ./src/styles/fonts/devicon/devicon.woff2
 ** module chunks = 0
 **/